export const callbackPreviousViewMap = {
  undefined: 'trueengage.channel_picker',
  schedule: 'trueengage.callback',
  'pre-interaction-form': 'trueengage.callback',
  'schedule-pre-interaction-form': 'trueengage.callback.schedule',
}

export const chatPreviousViewMap = {
  undefined: 'trueengage.channel_picker',
  'pre-interaction-form': 'trueengage.channel_picker',
}

export const whatsappPreviousViewMap = {
  undefined: 'trueengage.channel_picker',
}

export const facebookMessengerPreviousViewMap = {
  undefined: 'trueengage.channel_picker',
}

export const faqPreviousViewMap = {
  undefined: 'trueengage.channel_picker',
}

export const audioPreviousViewMap = {
  'pre-interaction-form': 'trueengage.audio',
  completed: 'trueengage.audio',
  undefined: 'trueengage.channel_picker',
}

export const videoPreviousViewMap = {
  'pre-interaction-form': 'trueengage.video',
  completed: 'trueengage.video',
  undefined: 'trueengage.channel_picker',
}

export const scheduledVideoPreviousViewMap = {
  'pre-interaction-form': 'trueengage.scheduledVideo',
  thanks: 'trueengage.scheduledVideo',
  undefined: 'trueengage.channel_picker',
}
